import { Component, Input } from '@angular/core';
import { environment } from '@environments/environment';
import { IntlService } from '@progress/kendo-angular-intl';
import { BaseCardComponent } from "./base-card.component";
import { AuthService } from '@app/core/services';
import { Router } from '@angular/router';


@Component({
  selector: 'receipt-card',
  styleUrls: ['./styles/styles-card.css'],
  styles: [`
    .card{
      height: 76px;
    }   
    .badge {
      padding: 0 4px 0 4px;
      color: white;
    }     
  `],
  template: `
    <!--{{receipt | json}}-->
    <div class="card" [class.border-top]="borderTop" (click)="selectItem($event)">
      <kendo-avatar [imageSrc]="receipt.type == 'SI' ? environment.assets.DEFAULT_SERVICE: environment.assets.DEFAULT_VEHICLE" shape="circle" style="background-size: contain; padding: 6px; background-color: #{{ receipt.status_color }}"></kendo-avatar>
      <div class="card-details">
        <div class="card-title">
          <span>{{ intl.formatNumber(receipt.amount, "c2", "en") }}</span> 
        </div>                
        <div class="card-subtitle no-wrap">
          {{ receipt.customer_name }} 
        </div>
        <div class="card-subtitle no-wrap">
          {{ receipt.payment_type_name }} 
          <span class="right"> {{ receipt.person_name }}</span>
        </div>
        
      </div>
      <!--<div class="card-actions" *ngIf="authService.hasPermission(['CREDITOS:EDITAR','CREDITOS:ELIMINAR'])">
        <span class="k-icon k-icon-md k-i-arrow-chevron-right k-color-secondary" style="color: #{{ receipt.credit_status_color }}!important"></span>
      </div>-->
    </div>
  `,    
})
export class ReceiptCardComponent extends BaseCardComponent {

  @Input() receipt!: any;

  @Input() returnUrl: string;

  public environment = environment;


  constructor(public intl: IntlService, public router: Router, public authService: AuthService) { 

    super(intl, router)

  }

  public selectItem(event: any) {

  //   this.router.navigate(['/receipt_edit/' + this.receipt.id], {state: {returnUrl: this.returnUrl}});

  }

}